export const userReducer = (state = {}, action) => {
  // const { type, payload } = action
  return state
}
